export default "__VITE_ASSET__BIlHz8U5__"